module.exports = __webpack_public_path__ + "static/media/8.288d90f1.svg";